function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.8
},
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-7694.914 -1674.674)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M7695.406 1692.739a.492.492 0 00.492-.492v-15.082a.492.492 0 00-.983 0v15.082a.492.492 0 00.491.492zM7698.028 1692.739a.492.492 0 00.492-.492v-15.082a.492.492 0 00-.983 0v15.082a.492.492 0 00.491.492zM7711.799 1692.739a.492.492 0 00.492-.492v-15.082a.492.492 0 00-.983 0v15.082a.492.492 0 00.491.492zM7714.422 1676.674a.492.492 0 00-.492.492v15.082a.492.492 0 00.983 0v-15.082a.492.492 0 00-.491-.492zM7705.242 1692.739a.492.492 0 00.492-.492v-15.082a.492.492 0 00-.983 0v15.082a.492.492 0 00.491.492z"
}),
/*#__PURE__*/
React.createElement("rect", {
  width: 2,
  height: 16,
  rx: 1,
  transform: "translate(7700.914 1676.674)"
}),
/*#__PURE__*/
React.createElement("rect", {
  width: 3,
  height: 16,
  rx: 1.5,
  transform: "translate(7706.914 1676.674)"
})),
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0 0h20v20H0z"
}));

var SvgSkuTracker = function SvgSkuTracker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgSkuTracker, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/SKUTracker.fe9b2359.svg";
export { ForwardRef as ReactComponent };